import { Component, EventEmitter, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DynamicFormsService, tipoSelect } from 'src/app/services/dynamic-forms.service';

@Component({
    selector: 'app-form-view-select',
    templateUrl: './form-view-select.component.html',
    styleUrls: ['./form-view-select.component.css'],
    standalone: false
})
export class FormViewSelectComponent implements OnInit {

  config:columnsDef;
  group: UntypedFormGroup;
  row:Object;
  toolTipText = null;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  tabindex:string;
  contentSelect:tipoSelect[];
  entityName:string;
  entityDesc:string;
  canConfig:boolean = false;
  
  constructor(public dynaServices:DynamicFormsService) {  }

  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  
  ngOnInit() {
    this.contentSelect = this.dynaServices.isSelect(this.config);
  }

  
  ngAfterViewInit(){
    
  }

  editing(){
    this.editEvent.next(true)
  }

}
